module.exports = __webpack_public_path__ + "static/media/Open.7fd05b4a.png";